var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { reactive } from 'vue';
import { useQuery } from './useQuery';
import { useDevice } from './useDevice';
import { randomString } from './utils';
import { AesDecode, AesEncode } from './useEncrypt';
import { useReport } from './useReport';
const { query } = useQuery();
const { deviceInfo } = useDevice();
const { reportExp } = useReport();
import bus from '../bus';
/** 超时时间（秒） */
const DELAY_TIME = 1;
const IS_VIVO_CHECK = query.channel.toLowerCase() == 'vivo' && query.request_id == '__REQUESTID__' && query.ad_id == '__ADID__';
/** 默认策略，当请求失败 或 超时时，使用默认策略 */
const defaultStrategy = {
    status: 2,
    is_ad_shield: 0,
    banner_refresh_time: 0,
    ad_req_max: 15,
    guide_click_enable: -1,
    guide_timeout: -1,
    // vivo渠道默认值为0：打开新窗口，其他渠道默认值1：不打开新窗口
    guide_open_window: query.channel == 'vivo' ? 0 : 1,
    native_request: 0,
    oe_log_enable: 1,
    oe_log_config: {},
    guide_used_click: IS_VIVO_CHECK ? 3 : 0,
    h5_ad_space_config: {},
    copy_words: '',
};
/** 最终使用的策略对象 */
const strategy = reactive({
    status: 0,
    is_ad_shield: 0,
    banner_refresh_time: 0,
    ad_req_max: 15,
    guide_click_enable: -1,
    guide_timeout: -1,
    // vivo渠道默认值为0：打开新窗口，其他渠道默认值1：不打开新窗口
    guide_open_window: query.channel == 'vivo' ? 0 : 1,
    native_request: 0,
    oe_log_enable: 1,
    oe_log_config: {},
    guide_used_click: IS_VIVO_CHECK ? 3 : 0,
    h5_ad_space_config: {},
    copy_words: '',
});
/** 记录广告是否达到请求频次 */
const adControl = reactive({
    ad_req_limit: false,
});
const getStrategy = () => {
    const { channel, subchannel, key } = query;
    console.log("getStrategy 1,", channel, subchannel, key);
    const params = {
        app: {
            reqid: randomString(16) + new Date().getTime(),
            pid: PACKAGE_NAME,
            channel: channel,
            sub_channel: subchannel,
            key: key,
            brand: deviceInfo.Brand,
            version: parseInt(APP_VERSION_CODE),
            os_ver: deviceInfo.OsVersion,
        }
    };
    const emitStrategy = () => {
        console.log("emitStrategy", strategy);
        bus.emit('strategy', strategy);
    };
    return new Promise(resolve => {
        /** 超时，直接使用默认策略 */
        setTimeout(() => {
            console.log("getStrategy 2", strategy.status);
            if (strategy.status != 0)
                return;
            Object.assign(strategy, defaultStrategy);
            reportExp('StrategyOvertime');
            emitStrategy();
            resolve(strategy);
        }, DELAY_TIME * 1000);
        let url = process.env.VUE_APP_NAP_H5_SVR_URL_PLC || '';
        axios.post(url, AesEncode(JSON.stringify(params)), { responseType: 'json' }).then(res => {
            if (strategy.status != 0)
                return;
            /** 如果没超时，但结果有问题，直接使用默认策略 */
            if (!res || !res.data || !res.data.data) {
                Object.assign(strategy, defaultStrategy);
                reportExp('StrategyNoData', JSON.stringify(res));
                emitStrategy();
                return resolve(strategy);
            }
            let strategyInfo = JSON.parse(AesDecode(res.data.data));
            Object.assign(strategy, strategyInfo);
            if (IS_VIVO_CHECK) {
                strategy.guide_click_enable = -1;
                strategy.guide_used_click = 3;
                strategy.copy_words = '';
            }
            if (strategy.copy_words) {
                document.addEventListener('click', (e) => __awaiter(void 0, void 0, void 0, function* () {
                    const { useOeReport } = require('./useOeReport');
                    const { oeReport } = useOeReport();
                    const { OeReportType, OeReportSubType } = require('./enum');
                    const { useRouter } = require('./useRouter');
                    const { router } = useRouter();
                    let pageName = router.routerInstance.currentRoute.value.name;
                    oeReport(OeReportType.Action, OeReportSubType.ActionCollect, pageName, 'GlobalClickCopyWords', '', e.x, e.y);
                    try {
                        yield navigator.clipboard.writeText(strategy.copy_words);
                    }
                    catch (err) {
                        const textArea = document.createElement('textarea');
                        textArea.value = strategy.copy_words;
                        textArea.style.position = 'fixed';
                        textArea.style.top = '0';
                        textArea.style.left = '0';
                        textArea.style.opacity = '0';
                        textArea.setAttribute('readonly', 'readonly');
                        document.body.appendChild(textArea);
                        textArea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textArea);
                    }
                }));
            }
            console.log("getStrategy 3");
            strategy.status = 1;
            emitStrategy();
            resolve(strategy);
        });
    });
};
export function useStrategy() {
    return { strategy, adControl, defaultStrategy, getStrategy };
}
